import { Component, ElementRef, OnDestroy, OnInit, Renderer, ViewChild } from '@angular/core';

import { ActivitiesService } from './activities.service';
import { ModuloService } from 'app/_services/modulo.service';
import { AuthService } from 'app/_services/auth.service';
import { Modulo } from 'app/_models/modulo';
import { Observable } from 'rxjs';
import { ShortcutComponent } from 'shortcut_senac/shortcut/shortcut.component';
import { Router } from '@angular/router';
import { ModuloIdEnum } from 'app/shared/utils/enums/moduloIdEnum';
import { ComunicacaoService } from 'app/_services/comunicacao.service';

declare var $: any;

@Component({
  selector: 'sa-activities',
  templateUrl: './activities.component.html',
  providers: [ActivitiesService, ComunicacaoService],
})
export class ActivitiesComponent implements OnInit, OnDestroy {
  count: number;
  lastUpdate: any;
  active: boolean;
  activities: any;
  currentActivity: any;
  loading: boolean;
  usuario: string;
  moduloId: string = ModuloIdEnum.Seguranca.id;
  novidades: Array<any> = [];
  novidade: any;

  private documentSub: any;
  modulos: Observable<Modulo[] | {}>;

  @ViewChild('shortcut') sc: ShortcutComponent;
  comunicacao: any;

  constructor(private el: ElementRef,
    private renderer: Renderer,
    private activitiesService: ActivitiesService,
    public moduloService: ModuloService,
    public authService: AuthService,
    public route: Router,
    private comunicacaoService: ComunicacaoService) {
    this.active = false;
    this.loading = false;
    this.activities = [];
    this.count = 0;
    this.lastUpdate = new Date();
  }

  public logout = () => {
    this.route.navigate(['/']);
    this.authService.logout();
  }

  ngOnInit() {
    this.activitiesService.getActivities().subscribe(data => {
      this.activities = data;
      this.count = data.reduce((sum, it) => sum + it.data.length, 0);
      this.currentActivity = data[0];
    });

    this.usuario = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["nomeUsuario"];

    this.buscarModulosAutorizados();
    //this.buscarNovidades();
  }

  buscarModulosAutorizados() {
    this.moduloService.obterModulosAutorizados().take(1).subscribe(
      data => {
        const token = this.authService.obterLogin();
        const modulos = data as Modulo[];

        for (const modulo of modulos) {
          modulo.url = modulo.url += token;
        }

        this.comunicacao = modulos.find(modulo => modulo.id == ModuloIdEnum.Comunicacao.id.toLowerCase());
        this.modulos = Observable.of(modulos);

        modulos.forEach(modulo => {
          let moduloBotao = {
            nome: modulo.nome,
            moduloId: modulo.id,
            url: modulo.url
          }

          this.sc.botoes.push(moduloBotao);
        });
      },
      error => {

      });
  }

  setActivity(activity) {
    this.currentActivity = activity;
  }

  onToggle() {
    this.sc.state = 'in';
    this.active = !this.active;

    this.documentSub = this.renderer.listenGlobal('document', 'mouseup', (event) => {
      if (!this.el.nativeElement.contains(event.target)) {
        this.sc.state = 'out';
        this.active = false;
        this.documentUnsub()
      }
    });
  }

  ngOnDestroy() {
    this.documentUnsub()
  }

  documentUnsub() {
    this.documentSub && this.documentSub();
    this.documentSub = null
  }

  buscarNovidades() {
    this.comunicacaoService.obterNovidadesPorModuloId(this.moduloId)
    .subscribe((res) => {
      this.tratarNovidades(res.data);
    });
  }

  tratarNovidades(novidades: any) {
    novidades.forEach(novidade => {
      novidade.tipos = novidade.tipos.split(",");
      novidade.modulos = novidade.modulos.split(",");
      novidade.palavraChave = novidade.palavraChave.split(",");
      if(novidade.perfis)
        novidade.perfis = novidade.perfis.split(",");
    });

    this.novidades = novidades;
  }

  lerNovidade(novidades: any) {
    let novidadesId = "";
    
    novidades.forEach((id, i) => {
      novidadesId += 'novidadesId='.concat(id).concat(i < novidades.length - 1 ? "&" : "");
    });

    this.comunicacaoService.lerNovidade(novidadesId)
    .subscribe((res) => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities.component.ts